import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshanpackagecab() {



  const cardData =
  {
    keyword: 'Pune Darshan Package Cab Booking',
    heading: 'Sanavi Travels: Pune Darshan Package Cab Booking',
    headingDescription: 'Sanavi Travels offers reliable Pune Darshan Package Cab Booking, providing safe, comfortable, and well-organized transportation for families, tourists, corporate groups, and small travel parties planning to explore Pune’s top attractions. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and enjoyable sightseeing experience. With professional chauffeurs, flexible half-day and full-day cab packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and hassle-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering key attractions such as Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Mandir, Sinhagad Fort, Pataleshwar Cave Temple, and Parvati Hill. Choose Sanavi Travels for trusted Pune Darshan package cab booking services, delivering comfort, safety, and a memorable city sightseeing experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "Pune Darshan Package Cab Booking",
    "description": "Pune Darshan Package Cab Booking offers travelers a comprehensive and convenient way to explore Pune’s famous landmarks, heritage sites, and cultural hotspots. Fully air-conditioned cabs with spacious seating and luggage space make the city tour comfortable for families, groups, and corporate travelers. Professional chauffeurs guide you through the best routes, ensuring timely arrivals at each destination. Flexible booking options and affordable packages make it easy to plan one-day sightseeing trips, weekend tours, or customized city excursions."
  },
  {
    "name": "Pune City Tour Cab",
    "description": "Pune City Tour Cab is designed for tourists and local travelers looking to explore Pune’s historic, cultural, and modern attractions. Air-conditioned cabs with comfortable seating and professional drivers provide a stress-free experience. Whether visiting Shaniwar Wada, Dagdusheth Ganpati Temple, Osho Ashram, or Pataleshwar Cave Temple, this service ensures a smooth, safe, and timely journey. Ideal for families, solo travelers, or group tours, it combines convenience, comfort, and reliable navigation for a memorable Pune sightseeing experience."
  },
  {
    "name": "AC Cab Pune Darshan",
    "description": "AC Cab Pune Darshan offers a cool and comfortable travel option for city sightseeing or pilgrimage tours within Pune. Fully air-conditioned vehicles provide ample legroom, luggage space, and a smooth ride. Professional chauffeurs ensure punctual pickups, safe driving, and knowledge of city routes to maximize sightseeing efficiency. Suitable for families, groups, or corporate travelers, this service makes exploring Pune’s temples, historical sites, and cultural centers convenient, comfortable, and enjoyable."
  },
  {
    "name": "Luxury Cab Pune Sightseeing",
    "description": "Luxury Cab Pune Sightseeing provides a premium experience for travelers seeking comfort, style, and convenience while exploring Pune. Fully air-conditioned luxury vehicles with spacious interiors and modern amenities allow families, friends, or corporate groups to enjoy their city tour in comfort. Experienced chauffeurs handle all navigation and traffic, ensuring a smooth and hassle-free ride. Ideal for personalized tours, sightseeing, cultural exploration, or weekend leisure trips, this service offers a high-end Pune travel experience."
  },
  {
    "name": "Family Cab Pune Darshan",
    "description": "Family Cab Pune Darshan is a reliable and comfortable travel solution for families looking to explore Pune together. Spacious cabs with air-conditioning, luggage space, and comfortable seating ensure a pleasant journey. Professional chauffeurs guide you safely to all popular landmarks, temples, and cultural attractions. Perfect for one-day trips, weekend city tours, or special occasions, this service prioritizes safety, convenience, and a stress-free travel experience for every family member."
  },
  {
    "name": "Affordable Cab Pune Tour",
    "description": "Affordable Cab Pune Tour offers budget-friendly options for travelers who want a comfortable city sightseeing experience without breaking the bank. Fully air-conditioned cabs with professional chauffeurs ensure a safe and enjoyable journey through Pune’s historical, cultural, and modern attractions. Ideal for students, families, groups, or solo travelers, this service combines affordability, convenience, and reliability for a memorable Pune tour experience."
  },
  {
    "name": "Chauffeur Driven Cab Pune",
    "description": "Chauffeur Driven Cab Pune provides a professional, safe, and convenient city tour experience for passengers exploring Pune. Experienced drivers manage navigation, traffic, and parking, allowing passengers to relax and enjoy their tour. Fully air-conditioned, spacious vehicles with luggage space accommodate families, friends, and corporate groups comfortably. Suitable for sightseeing, temple visits, heritage tours, or weekend trips, this service guarantees comfort, safety, and punctuality for every journey."
  },
  {
    "name": "Best Pune Darshan Cab",
    "description": "Best Pune Darshan Cab is a premium service for travelers seeking the most comfortable and efficient way to explore Pune’s attractions. Fully air-conditioned, well-maintained vehicles provide a smooth ride, while professional chauffeurs ensure safe and timely navigation to all popular landmarks. Ideal for families, tourists, corporate groups, or solo travelers, this service prioritizes convenience, reliability, and a memorable sightseeing experience."
  },
  {
    "name": "Pune Local Sightseeing Cab",
    "description": "Pune Local Sightseeing Cab offers a convenient option for exploring the city’s famous sites, temples, gardens, and cultural hotspots. Air-conditioned vehicles with comfortable seating make city travel stress-free, while professional chauffeurs guide you efficiently through traffic and routes. Suitable for families, tourists, and corporate travelers, this service ensures a safe, timely, and enjoyable sightseeing experience within Pune."
  },
  {
    "name": "Tourist Cab Pune",
    "description": "Tourist Cab Pune is designed for visitors who want to explore Pune’s heritage, temples, cultural centers, and modern attractions in comfort. Spacious, air-conditioned vehicles provide a relaxing travel experience, while chauffeurs ensure safe and timely navigation to all landmarks. This service is ideal for families, groups, and solo travelers seeking an efficient and hassle-free city tour experience."
  },
  {
    "name": "One Day Pune Darshan Cab",
    "description": "One Day Pune Darshan Cab is perfect for travelers planning a short excursion around Pune. Fully air-conditioned, spacious vehicles ensure a comfortable journey, while professional chauffeurs guide visitors to all key landmarks, temples, and cultural sites efficiently. This service is ideal for families, groups, or solo tourists who want to cover Pune’s top attractions in a single day, combining convenience, comfort, and reliability."
  },
  {
    "name": "Corporate Pune Tour Cab",
    "description": "Corporate Pune Tour Cab caters to companies and business groups looking for organized sightseeing, city tours, or client entertainment within Pune. Comfortable, air-conditioned cabs with professional chauffeurs ensure timely pickups, safe travel, and efficient navigation. Perfect for team outings, corporate events, or incentive trips, this service provides a seamless combination of professionalism, convenience, and comfort for corporate travelers."
  },
  {
    "name": "Airport Pickup Cab Pune",
    "description": "Airport Pickup Cab Pune offers a reliable and comfortable transfer service from Pune Airport to your hotel, residence, or city sightseeing locations. Fully air-conditioned cabs with spacious seating and luggage space ensure a smooth ride, while professional chauffeurs handle navigation, flight timings, and traffic. This service is ideal for tourists, families, corporate travelers, and anyone seeking a stress-free arrival or departure experience in Pune."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to reserve their Pune Darshan cabs conveniently from anywhere, anytime. Passengers can select cab type, pickup location, travel date, and duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs provide a comfortable, safe, and timely journey. This service is suitable for city tours, temple visits, corporate travel, or family outings, combining convenience, reliability, and modern technology for hassle-free travel."
  },
  {
    "name": "Pune Travel Cab",
    "description": "Pune Travel Cab offers a dependable and comfortable option for exploring Pune’s heritage, temples, gardens, and cultural landmarks. Air-conditioned, well-maintained cabs with spacious seating and luggage space provide a relaxing travel experience. Experienced chauffeurs ensure safe navigation and timely arrivals at each destination. Ideal for families, groups, tourists, and corporate travelers, this service guarantees convenience, comfort, and a memorable Pune sightseeing experience."
  }
],
"tableData": [
  ["Pune Darshan Package Cab Booking", "Pune City Tour Cab"],
  ["AC Cab Pune Darshan", "Luxury Cab Pune Sightseeing"],
  ["Family Cab Pune Darshan", "Affordable Cab Pune Tour"],
  ["Chauffeur Driven Cab Pune", "Best Pune Darshan Cab"],
  ["Pune Local Sightseeing Cab", "Tourist Cab Pune"],
  ["One Day Pune Darshan Cab", "Corporate Pune Tour Cab"],
  ["Airport Pickup Cab Pune", "Online Cab Booking Pune"],
  ["Pune Travel Cab", "—"]
]

,


"whychoose": [
  {
    "WhyChooseheading": "Pune Darshan Package Cab Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers convenient and reliable Pune Darshan cab packages, perfect for sightseeing, family trips, group outings, and exploring Pune’s popular attractions."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced cabs to enjoy a comfortable and smooth sightseeing experience in Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, courteous, and knowledgeable about Pune’s sightseeing routes, ensuring safe and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear, upfront pricing for Pune Darshan packages, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and any travel-related inquiries."
  },
  {
    "WhyChooseheading": "Flexible Package Options",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized Pune Darshan cab packages tailored to your sightseeing requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune Darshan cab bookings."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune Darshan cab packages?',
    answer: 'Yes, Sanavi Travels offers well-planned and comfortable Pune Darshan cab packages for sightseeing and local travel.'
  },
  {
    question: 'How can I book a Pune Darshan cab package?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of cabs are available for Pune Darshan packages?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars for a comfortable sightseeing experience.'
  },
  {
    question: 'Are drivers knowledgeable about Pune sightseeing routes?',
    answer: 'Yes, our drivers are experienced and familiar with all major tourist spots in Pune.'
  },
  {
    question: 'Can I customize my Pune Darshan package?',
    answer: 'Absolutely. We offer half-day, full-day, or fully customized packages to suit your preferences.'
  },
  {
    question: 'Is the Pune Darshan cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock services for booking and travel assistance.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every sightseeing trip.'
  },
  {
    question: 'What payment options are available for Pune Darshan bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune Darshan journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Joshi',
    feedback: 'Booked a Pune Darshan package with Sanavi Travels. Excellent service, comfortable cab, and the driver was very knowledgeable!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Meera Kulkarni',
    feedback: 'Amazing experience! The cab was clean, the driver was courteous, and we enjoyed sightseeing Pune without any hassle.',
    rating: 5
  }
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Package Cab Booking - Sanavi Travels",
  "description": "Book Pune Darshan cabs with Sanavi Travels. AC and luxury cabs for city sightseeing, family trips, corporate tours, airport pickups, one-day excursions, and comfortable chauffeur-driven Pune travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Pune Darshan Package Cab Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs in Pune for city sightseeing with Sanavi Travels. Ideal for family trips, corporate tours, airport pickups, one-day Pune Darshan, and safe chauffeur-driven travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/169.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punedarshanpackagecab;